import React from 'react';
import GoogleLogoImg from './GoogleLogo.png';

const GoogleWorkspaceLogo: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg
    width={78.6}
    height={76.8}
    viewBox="0 0 65.5 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <image href={GoogleLogoImg} width="65.5" height="64" preserveAspectRatio="xMidYMid meet" />
  </svg>
);

export default GoogleWorkspaceLogo;
